// ----- OUTBOUND (UI -> API) -----
export const toCompanyCreateDTO = (companyHash, cantonId) => ({
  hash: companyHash,
  cantonId,
});

export const toCompanyPatchCantonDTO = (companyHash, cantonId) => ({
  hash: companyHash,
  cantonId,
});

export const toCompanyInputCreateDTO = (surveyId, companyId) => ({
  surveyId,
  invalid: true,
  initialized: true,
  collecting: new Date().toISOString(),
  companyId,
});

export const toCompanyDetailPatchDTO = (companyInputId, nogaId, officeSizeId) => ({
  companyInputId,
  nogaId,
  officeSizeId,
});

export const toCompanyDetailCreateDTO = (companyInputId, nogaId, officeSizeId) => ({
  companyInputId,
  nogaId,
  officeSizeId,
});

export const toCompanyInputSubmitDTO = (companyId, surveyId, collecting, clientReply) => ({
  companyId,
  surveyId,
  initialized: true,
  invalid: true,
  inputComplete: true,
  collecting,
  submitted: new Date().toISOString(),
  clientReply,
});

export const toCompanyInputReopenDTO = (companyId, surveyId) => ({
  companyId,
  surveyId,
  initialized: true,
  invalid: true,
  inputComplete: false,
  trusteeReview: "user reopen",
});
// ----- INBOUND (API -> UI) -----
export const fromCompanyDTO = (dto) => dto;
export const fromCompanyInputDTO = (dto) => dto;
export const fromCompanyDetailDTO = (dto) => dto;
